import React from 'react';
import { Clear } from 'icons';
import * as S from './styles';
import { ChipProps } from './types';

function ForwardedChip<
  T extends Element = HTMLDivElement,
  As extends React.ElementType = 'div',
>(props: ChipProps<As>, forwardedRef: React.ForwardedRef<T>) {
  const { as, children, onClose, permanent, ...restProps } = props;

  const Component: React.ElementType = as ?? 'div';

  return (
    <S.Root
      forwardedAs={Component}
      $permanent={!!permanent}
      ref={forwardedRef}
      {...restProps}
    >
      <S.Content>{children}</S.Content>
      {!permanent && (
        <S.CloseButton onPress={onClose}>
          <Clear />
        </S.CloseButton>
      )}
    </S.Root>
  );
}

export const Chip = React.forwardRef(ForwardedChip) as <
  T extends Element = HTMLDivElement,
  As extends React.ElementType = 'div',
>(
  props: ChipProps<As> & { ref?: React.Ref<T> },
) => React.ReactElement | null;

export default Chip;
